import ApiService from './ApiService';

const SchedulesService = {
  list: () => ApiService.get('/schedules'),
  create: (schedule) => ApiService.post('/schedules', schedule),
  update: (id, fields) => ApiService.patch(`/schedules/${id}`, fields),
  remove: (id) => ApiService.del(`/schedules/${id}`),
  runNow: (id) => ApiService.post(`/schedules/${id}/run`),
};

export default SchedulesService;
